import { get } from '../utils/api';

/**
 * 流水线服务
 */
export const assemblyLineService = {
  // 获取用户流水线记录
  getUserAssemblyLines: async (walletAddress) => {
    const response = await get(`/assembly-lines/user/${walletAddress}`);
    return response.data;
  },

  // 获取流水线列表
  getAssemblyLineList: async (page = 1, size = 10, walletAddress = '') => {
    const params = { page, size };
    if (walletAddress) params.walletAddress = walletAddress;
    const response = await get('/assembly-lines', params);
    return response.data;
  },
};

